import React from 'react'
import PropTypes from 'prop-types'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction'
import connectPropTypes from '../utilities/connectPropTypes'
import shortNumber from '../utilities/shortNumber'
import linkTypes from '../enums/linkTypes'
import { firestore } from '../utilities/firebase'
import getCurrentUid from '../utilities/getCurrentUid'
import getField from '../utilities/Data/getField'
import styles from './BottomAppBar.icss'

class BottomAppBar extends React.Component {
	constructor(props) {
		super(props)
		this.handleChange = this.handleChange.bind(this)
		this.unsubscribeObserver = undefined
	}

	componentDidMount() {
		const uid = getCurrentUid()
		if (uid) {
			const qs = firestore.collection('userProfiles').doc(uid).collection('notifications').where('hasSeenNotification', '==', false)
			this.unsubscribeObserver = qs.onSnapshot((querySnapshot) => {
				const notificationsUnread = querySnapshot.size
				this.props.notificationStatus({ notificationsUnread })
			}, (err) => {
				console.error(`Encountered error: ${err}`)
			})
		}
	}

	componentWillUnmount() {
		if (this.unsubscribeObserver) {
			this.unsubscribeObserver()
		}
	}

	handleChange(e, value) {
		let redir
		if (value === linkTypes.USER) {
			redir = `/user/${getField(this.props.user, 'userProfile.userName')}`
		} else if (value === linkTypes.HOME) {
			if (this.props.bottomBarValue === linkTypes.HOME) {
				global.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
			} else {
				redir = '/'
			}
		} else if (value === linkTypes.ADD) {
			redir = '/postkit'
		} else if (value === linkTypes.SEARCH) {
			if (value !== this.props.bottomBarValue) {
				redir = '/search'
			}
		} else if (value === linkTypes.NOTIFICATIONS) {
			if (value !== this.props.bottomBarValue) {
				redir = '/notifications'
			}
		} else {
			console.log('GOT UNKNOWN ACTION', value)
		}
		if (redir) {
			this.props.searchParametersClear()
			this.props.appRedirect(redir)
		}
	}

	render() {
		const user = this.props.user || { isActivated: false }
		return (
			<div>
				<BottomNavigation
					onChange={this.handleChange}
					classes={{ root: styles.appBar }}
					value={this.props.bottomBarValue}
				>
					{Object.keys(linkTypes).map((key) => {
						const linkType = linkTypes[key]
						let linkIcon = user.isActivated ? linkType.icon : linkType.iconDisabled
						if (linkType === this.props.bottomBarValue) {
							linkIcon = linkType.iconActive
						}
						if (linkType.type === linkTypes.NOTIFICATIONS.type && this.props.notificationsUnread > 0) {
							linkIcon = (
								<>
									{linkIcon}
									<span className={styles.notificationsUnreadBubble}>{shortNumber(this.props.notificationsUnread)}</span>
								</>
							)
						}
						return (
							<BottomNavigationAction
								disabled={!user.isActivated}
								value={linkType}
								key={`action_${linkType.type}`}
								classes={{ root: styles.button, selected: styles.selectedButton }}
								icon={linkIcon}
							/>
						)
					})}
				</BottomNavigation>
				<div className={styles.offset} />
			</div>
		)
	}
}

BottomAppBar.propTypes = {
	notificationStatus: PropTypes.func.isRequired,
	notificationsUnread: PropTypes.number,
	searchParametersClear: PropTypes.func.isRequired,
	appRedirect: PropTypes.func.isRequired,
	bottomBarValue: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}

BottomAppBar.defaultProps = {
	notificationsUnread: undefined,
	bottomBarValue: undefined
}

BottomAppBar.contextTypes = {
	translate: PropTypes.func
}

export const testing = {
	BottomAppBar
}

export default connectPropTypes(BottomAppBar)



// WEBPACK FOOTER //
// ./src/components/BottomAppBar.jsx